import React from 'react'
import "../styles/footer.css"
const Footer = () => {
  return (
    <div className='footerContainer'>
        <a href="https://www.sebi.gov.in/website-policy.html#terms" target="_blank">Terms & Conditions</a> &nbsp;|&nbsp; <a href="https://www.sebi.gov.in/website-policy.html#privacypolicy" target="_blank">Privacy Policy</a>
    </div>
  )
}

export default Footer